import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/medal_silver.png")